module.exports = function() {
  return new Worker(__webpack_public_path__ + "f6d8264319eb2cd2fabb.worker.js");
};